// Drawer side navigation for small devices
export default function initMenu() {
  const nav = document.querySelector('.Menu-nav');
  const navList = document.querySelector('.Menu-navList');
  const overlay = document.querySelector('.Menu-overlay');
  const burger = document.querySelector('.js-burger');
  
  burger.addEventListener('click', function () {
    let burgerExpanded = burger.getAttribute('aria-expanded') === 'true' || false;
    this.setAttribute('aria-expanded', !burgerExpanded);
    this.classList.toggle('is-active');
    nav.classList.toggle('is-visible');
    overlay.classList.toggle('is-visible');
    navList.classList.toggle('hidden');
  });
  
}